// import 'es6-promise/auto'
// import 'html5-history-api'
// import qs from 'qs'
import axios from 'axios';
import { Message } from 'view-design';
import config from '~/config';
import { getToken } from '~/utils/cookie';
export default function(options, theConfig) {
  return new Promise((resolve, reject) => {
    options = options || {};
    const baseURl =
      typeof window === 'undefined' ? config.PortalBaseURL : config.PortalBrowserBaseURL;
    let url = baseURl + theConfig.url;
    // let url = '/portal' + theConfig.url
    theConfig.method = theConfig.method.toLocaleLowerCase();

    if (options.query) {
      const query = options.query;
      const queryArr = [];
      for (const key in query) {
        if (query.hasOwnProperty(key)) {
          queryArr.push(key + '=' + query[key]);
        }
      }
      if (queryArr.length > 0) {
        url += '?' + queryArr.join('&');
      }
    }
    const axiosConfig = {
      method: theConfig.method,
      url,
      headers: {
        area_code: getToken() || 'jiangsu',
      },
    };
    // console.log(url);
    if (theConfig.needStaffId) {
      axiosConfig.headers.staffId = options.headers.staffId || '';
    }

    if (theConfig.method === 'post' || theConfig.method === 'put') {
      axiosConfig.data = options.body || {};
    }

    const client = options.client;
    if (client && client.headers) {
      if (client.headers.cookie) {
        axiosConfig.headers.Cookie = client.headers.cookie;
      }
    }
    if (theConfig.headers) {
      axiosConfig.headers = Object.assign(axiosConfig.headers, theConfig.headers);
    }
    const noNotice = theConfig.noNotice;
    // const source = CancelToken.source(); 
    // const cancel = source.cancel;
    axios(axiosConfig)
      .then(function(response) {
        return resolve(response.data);
      })
      .catch(function(error) {
        if (error.response) {
          let errorObj = {};
          if (error.response.status == 400) {
            errorObj = Object.assign({}, { statusCode: 400 }, error.response.data);

            if (
              !noNotice &&
              !client &&
              errorObj.message !== undefined &&
              errorObj.message != '没有查询到该专利价值评估数据' &&
              errorObj.message != '没有查询到该企业创新能力分析数据'
            ) {
              // 服务端只提示业务逻辑异常
              Message.error(errorObj.message);
            }
          } else {
            errorObj = {
              code: error.response.status,
              message: error.response.statusText,
              statusCode: error.response.status,
            };
          }
          return resolve(errorObj);
        }
        return reject(error);
      });
  });
}
